import React from 'react';
import { TrashIcon } from './SolarIcon';

interface TrashButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  className?: string;
}

/**
 * TrashButton — small unstyled button rendering the solar trash icon.
 * Shared by every item editor's Question-field trailing trash action.
 */
export default function TrashButton({ onClick, ariaLabel = 'Delete', className = '' }: TrashButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`p-1 border-0 bg-transparent cursor-pointer hover:opacity-80 transition-opacity ${className}`}
    >
      <TrashIcon />
    </button>
  );
}
